import React from "react";

export default function NotFound() {
	return (
		<div className="NotFound">
			<p>Page not found!</p>
		</div>
	);
}
